<template>
  <el-container direction="vertical" class="portals">
    <el-main>
      <el-row class="m-t-10 m-b-10">
        <el-col>
          <el-card class="box-card affairs-card">
            <el-row>
              <el-col :span="24">
                <el-input
                  clearable
                  v-model="queryInfo"
                  placeholder="请输入您要搜索的内容"
                  class="top-search-block"
                >
                  <el-button
                    class="right-content"
                    slot="append"
                    icon="el-icon-search"
                    @click="keypress(queryInfo)"
                  ></el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="19" class="col-sty" v-loading="vloading">
                <div
                  v-if="listdata && listdata.length === 0"
                  style="height: 300px; padding-left: 300px"
                >
                  <p>抱歉，没有找到相关结果。建议：</p>
                  <p>1. 请您检查输入是否错误</p>
                  <p>2. 请您尝试简化输入词</p>
                  <p>3. 请您尝试用相似词或常见词</p>
                </div>
                <template v-if="listdata && listdata.length > 0">
                  <div
                    v-for="(i, key) in listdata"
                    style="margin-bottom: 22px"
                    shadow="never"
                    :key="key"
                  >
                    <p style="margin: 0">
                      <a @click="release(i)">
                        <div
                          v-html="i.articleTitle"
                          style="
                            color: #015092;
                            font-family: Microsoft YaHei;
                            font-size: 16px;
                            font-weight: 100;
                          "
                        ></div>
                      </a>
                    </p>

                    <p
                      class="text-align-l"
                      style="
                        line-height: 22px;
                        color: #333333;
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 100;
                        margin: 5px 0;
                      "
                      v-html="i.describe"
                    ></p>
                    <el-row>
                      <div>
                        <span
                          style="
                            color: #888888;
                            font-size: 13px;
                            font-family: Microsoft YaHei;
                            padding-right: 10px;
                          "
                          >发布时间：{{ i.publishDate | filterPrice }}</span
                        >
                      </div>
                      <!-- </el-col> -->
                    </el-row>
                  </div>
                </template>
                <div class="paginationstyle">
                  <el-pagination
                    popper-class="pageclass"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPageNumber"
                    :page-sizes="[10, 20, 40, 80]"
                    :page-size="pageSize"
                    prev-text="＜ 上一页"
                    next-text="下一页 ＞"
                    layout="total, prev, pager, next"
                    :total="total"
                  ></el-pagination>
                </div>
              </el-col>
              <el-col :span="5" style="padding: 10px">
                <div class="text-align-l m-b-10">
                  <h4>时间筛选</h4>
                </div>
                <div class="text-align-l">
                  <el-button
                    :type="type == 'all' ? 'primary' : 'text'"
                    @click="timesearch('all')"
                    size="medium"
                    >全部
                  </el-button>
                </div>
                <div class="text-align-l">
                  <el-button
                    :type="type == 'day' ? 'primary' : 'text'"
                    @click="timesearch('day')"
                    size="medium"
                    >一天内
                  </el-button>
                </div>
                <div class="text-align-l">
                  <el-button
                    :type="type == 'week' ? 'primary' : 'text'"
                    @click="timesearch('week')"
                    size="medium"
                    >一周内
                  </el-button>
                </div>
                <div class="text-align-l">
                  <el-button
                    :type="type == 'month' ? 'primary' : 'text'"
                    @click="timesearch('month')"
                    size="medium"
                    >一月内
                  </el-button>
                </div>
                <div class="text-align-l">
                  <el-button
                    :type="type == 'year' ? 'primary' : 'text'"
                    @click="timesearch('year')"
                    size="medium"
                    >一年内
                  </el-button>
                </div>
                <div class="text-align-l">
                  <el-button
                    :type="type == '1' ? 'primary' : 'text'"
                    @click="timesearch('1')"
                    size="medium"
                    >指定时间
                  </el-button>
                </div>
                <el-row style="height: 10px"></el-row>
                <div v-if="showTime">
                  <div class="m-b-10 text-align-l">
                    <el-date-picker
                      popper-class="timeclass"
                      v-model="dateStart"
                      type="date"
                      placeholder="开始日期"
                      size="mini"
                      unlink-panels
                      value-format="yyyy-MM-dd"
                      style="width: 80%"
                      @change="dateStartChange()"
                    ></el-date-picker>
                  </div>
                  <el-row style="height: 10px"></el-row>
                  <div class="text-align-l">
                    <el-date-picker
                      popper-class="timeclass"
                      v-model="dateEnd"
                      type="date"
                      unlink-panels
                      value-format="yyyy-MM-dd"
                      placeholder="结束日期"
                      size="mini"
                      style="width: 80%"
                      @change="dateEndChange()"
                    ></el-date-picker>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import moment from "moment";
import {} from "../../utils/api";
import util from "../../utils/util";
export default {
  data() {
    return {
      type: "all",
      queryInfo: "",
      findText: null,
      vloading: false,
      showTime: false,
      pubdateStart: "",
      pubdateEnd: "",
      // 自定义开始日期   结束日期
      dateStart: "",
      dateEnd: "",
      currentPageNumber: 1,
      pageSize: 50,
      total: 0,
      listdata: [],
    };
  },
  filters: {
    filterPrice: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "-" + MM + "-" + d;
      }
    },
  },
  mounted() {
    this.queryInfo = this.$route.query.queryInfo;
    console.log(this.queryInfo);
    // this.timesearch();
    this.keypress(this.$route.query.queryInfo);
  },
  methods: {
    // 开始时间改变
    dateStartChange() {
      this.pubdateStart = this.dateStart;
      this.keypress(this.queryInfo);
    },
    // 结束时间改变
    dateEndChange() {
      this.pubdateEnd = this.dateEnd;
      this.keypress(this.queryInfo);
    },
    // 搜索
    keypress(val) {
      if (val) {
        let Url = util.getAjaxUrl("axiosThree");
        let params = {
          currentPage: this.currentPageNumber,
          displayDateEnd: this.pubdateEnd,
          displayDateStart: this.pubdateStart,
          highlight: 1,
          keyWord: val,
          pageSize: this.pageSize,
        };
        this.$http.post(Url + "/api/es/find", params).then((res) => {
          if (res.status == 200) {
            if (res.data.code) {
              this.total = res.data.data.pagination.totalNum;
              this.listdata = res.data.data.data;
            }
          }
        });
      }
    },
    // 侧边时间区间
    timesearch(time) {
      this.type = time;
      let timedata = moment().format("YYYY-MM-DD");
      if (time == "1") {
        this.showTime = true;
      } else {
        this.showTime = false;
      }
      if (time == "day") {
        this.pubdateStart = moment(timedata)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        this.pubdateEnd = moment().format("YYYY-MM-DD");
      } else if (time == "week") {
        this.pubdateStart = moment(timedata)
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        this.pubdateEnd = moment().format("YYYY-MM-DD");
      } else if (time == "month") {
        this.pubdateStart = moment(timedata)
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        this.pubdateEnd = moment().format("YYYY-MM-DD");
      } else if (time == "year") {
        this.pubdateStart = moment(timedata)
          .subtract(365, "days")
          .format("YYYY-MM-DD");
        this.pubdateEnd = moment().format("YYYY-MM-DD");
      } else {
        this.pubdateStart = "";
        this.pubdateEnd = "";
      }
      this.keypress(this.queryInfo);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.keypress(this.queryInfo);
    },
    handleCurrentChange(val) {
      this.currentPageNumber = val;
      this.keypress(this.queryInfo);
    },
    // 点击进入详情
    release(val) {
      this.$router.push({
        path: "/goverment-search-release",
        query: { id: val.articleId },
      });
    },
  },
};
</script>
<style scoped lang="less">
.paginationstyle {
  text-align: center;
}
.col-sty {
  border-right: 1px solid #dcdfe6;
  padding: 10px;
}

a {
  text-decoration: none;
}

.el-main {
  padding: 0;
  background: #f3f3f3;
}

#home-notify-title {
  height: 30px;
  line-height: 30px;
  color: #585856;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-button--text {
  color: #303133;
}
/deep/.el-pager li.active {
  color: #b71c1c;
}
.text-align-r {
  text-align: right;
}
/* B71C1C */
.el-button--primary {
  background-color: #b71c1c;
  border-color: #b71c1c;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #b71c1c;
}
/deep/.el-input__inner:focus {
  border-color: #b71c1c;
}
.right-content {
  line-height: 17px;
  color: #fff !important;
  border-color: #b71c1c !important;
  background-color: #b71c1c !important;
}
</style>
